import { Transition, TransitionService } from '@uirouter/core';

import { SessionService } from '../../app-lite/sessions/session.service';

export function AdminDashboardResolver (
  $transitions : TransitionService,
  sessionObjAPI: SessionService
) {
  $transitions.onStart({
    to: 'app.admin-dashboard'
  }, ( transition : Transition ) => {
    if ( !sessionObjAPI.isSuperUser() ) {
      return false;
    }
  });
}
